import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import BaseCarousel from '@bibliocommons/carousel-base';
import RatingCard from '@bibliocommons/rating-card';

import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import { METADATA_CATEGORY_TYPE } from 'app/constants/AnalyticsGa4Constants';

const RecentlyRatedCarousel = ({ breakpointSettings, items, titleData }) => {
  const dispatch = useDispatch();

  const trackJacketClick = item => {
    dispatch(
      trackContentClick({
        bib: {
          bib_format: item.format,
          bib_metadata_id: item.metadataId
        },
        metadata: {
          metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
          metadata_value: item.title
        },
        ui: {
          ui_component_type: 'link-image',
          ui_container_title: titleData.carouselTitle,
          ui_container_type: 'carousel'
        }
      })
    );
  };

  return (
    <BaseCarousel.BaseCarousel breakpointSettings={breakpointSettings} titleData={titleData}>
      {items.map(ratingCardProps => {
        const { item } = ratingCardProps;
        return <RatingCard key={item.id} {...ratingCardProps} onJacketClick={() => trackJacketClick(item)} />;
      })}
    </BaseCarousel.BaseCarousel>
  );
};

RecentlyRatedCarousel.propTypes = {
  breakpointSettings: PropTypes.objectOf(
    PropTypes.shape({
      gutterSize: PropTypes.string,
      itemsPerPage: PropTypes.number,
      partiallyShowOffscreenItems: PropTypes.bool,
      showDots: PropTypes.bool,
      useTouchArrows: PropTypes.bool
    })
  ),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        title: PropTypes.string,
        id: PropTypes.string,
        format: PropTypes.string,
        jacket: PropTypes.shape({
          medium: PropTypes.string
        }).isRequired
      }).isRequired,
      creator: PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string
      }).isRequired,
      rating: PropTypes.shape({
        rating: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        metadataId: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  ),
  titleData: PropTypes.shape({
    carouselTitle: PropTypes.string.isRequired,
    carouselTitleLink: PropTypes.string,
    headingTag: PropTypes.string.isRequired
  }).isRequired
};

RecentlyRatedCarousel.defaultProps = {
  items: []
};

export default RecentlyRatedCarousel;
